import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  get #sectionId() {
    return this.querySelector('[data-section-id]')?.dataset.sectionId;
  }

  #handleCartAdd = async () => {
    await this.#refreshSection();
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  #refreshSection = async () => {
    const sectionId = this.#sectionId;
    if (!sectionId) return;
    try {
      const response = await fetch(`${window.location.pathname}?sections=${sectionId}`, {
        headers: { 'x-requested-with': 'XMLHttpRequest' }
      });
      if (!response.ok) return;
      const data = await response.json();
      const html = data[sectionId];
      if (!html) return;
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDialog = doc.querySelector('.cart-drawer__dialog');
      const currentDialog = this.querySelector('.cart-drawer__dialog');
      if (newDialog && currentDialog) {
  const wasOpen = currentDialog.hasAttribute('open');
  currentDialog.innerHTML = newDialog.innerHTML;
  // Sync les classes (notamment cart-drawer--empty)
  currentDialog.className = newDialog.className;
  if (wasOpen) currentDialog.setAttribute('open', '');
}
    } catch (err) {
      console.error('[CartDrawer] Refresh error:', err);
    }
  };

  open() {
    this.showDialog();
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}